import { Uuid } from '@softline/core';
import { Filter } from '../types/filter';

/**
 * Returns the tree without the node identified by uuid (immutably).
 * Condition groups left empty become null, single-child groups collapse.
 * When the uuid is not found the original tree is returned unchanged.
 */
export function excludeFilterNode<T extends object>(
  tree: Filter<T> | null,
  uuid: Uuid
): Filter<T> | null {
  if (!tree) return null;
  const result = removeNode(tree, uuid);
  return result === undefined ? tree : result;
}

function removeNode<T extends object>(
  node: Filter<T>,
  uuid: Uuid
): Filter<T> | null | undefined {
  if (node.uuid === uuid) return null;
  if (node.type !== 'conditions') return undefined;
  let removed = false;
  const filters: Filter<T>[] = [];
  for (const child of node.filters) {
    const result = removeNode(child, uuid);
    if (result === undefined) filters.push(child);
    else {
      removed = true;
      if (result !== null) filters.push(result);
    }
  }
  if (!removed) return undefined;
  if (filters.length === 0) return null;
  if (filters.length === 1) return filters[0];
  return { ...node, filters };
}
